import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=3c4ff7fc&scoped=true&"
var script = {}
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=3c4ff7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ff7fc",
  null
  
)

export default component.exports